import React from 'react';

export const AutoIcon = () => (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.99697 10.1611C5.33073 10.1611 3.22857 13.5481 1.32114 11.1288C1.12435 10.8792 1.02398 10.5781 1.00383 10.2377C0.940882 9.17445 1.67302 8.26084 2.31949 7.41439C3.64731 5.67583 5.09086 3.57825 6.23508 2.04335C7.21197 0.732937 8.80067 0.712342 9.82008 1.98996C11.1271 3.62801 12.7841 5.93057 14.0394 7.74782C14.4635 8.3617 14.8704 9.01389 14.9731 9.75289C15.0485 10.2952 14.9705 10.7663 14.6728 11.1288C12.686 13.5481 10.6632 10.1611 7.99697 10.1611Z"
            stroke="currentColor"
            strokeWidth="1.3"
        />
    </svg>
);
